import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=b0f9ee2c&scoped=true&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=b0f9ee2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f9ee2c",
  null
  
)

export default component.exports